<template>
  <!--
    Fusion Eat dots menu — the console's seldom-used reports.

    Orders and Production are the daily work and keep their buttons on the
    page; everything else is periodic or one-time (Maurizio, 2026-09-18: "the
    client part is one time only", "all other are periodic/seldom used
    features"), so it lives here, the way the other modules put their
    occasional actions in the app bar. Every report is listed, the two daily
    ones included, so the menu is a complete map of the console rather than a
    remainder.
  -->
  <v-bottom-sheet v-model="showMealsMenu" inset class="rounded" width="90%">
    <v-list density="comfortable">
      <MenuSheetTitle @close="showMealsMenu = false" />

      <v-divider></v-divider>

      <v-list-subheader class="text-uppercase">On the page</v-list-subheader>
      <v-list-item
        v-for="r in dailyReports"
        :key="r.key"
        :active="report === r.key"
        @click="open(r.key)"
      >
        <template v-slot:prepend><v-icon :icon="r.icon" :color="r.color"></v-icon></template>
        <template v-slot:title>{{ r.title }}</template>
        <template v-slot:subtitle>{{ r.subtitle }}</template>
      </v-list-item>

      <v-divider class="my-1"></v-divider>

      <v-list-subheader class="text-uppercase">Only here</v-list-subheader>
      <v-list-item
        v-for="r in occasionalReports"
        :key="r.key"
        :active="report === r.key"
        @click="open(r.key)"
      >
        <template v-slot:prepend><v-icon :icon="r.icon" :color="r.color"></v-icon></template>
        <template v-slot:title>{{ r.title }}</template>
        <template v-slot:subtitle>{{ r.subtitle }}</template>
      </v-list-item>
    </v-list>
  </v-bottom-sheet>
</template>

<script setup>
import MenuSheetTitle from "@/components/MenuSheetTitle.vue";
import { useApp } from "@/composables/useApp.js";
import { useMeals } from "@/composables/useMeals.js";
import { MEALS_REPORTS, DAILY_REPORT_KEYS } from "@/config/mealsReports.js";

const { showMealsMenu } = useApp();
const { report } = useMeals();

const dailyReports = MEALS_REPORTS.filter((r) => DAILY_REPORT_KEYS.includes(r.key));
const occasionalReports = MEALS_REPORTS.filter((r) => !DAILY_REPORT_KEYS.includes(r.key));

/** Switch the console to a report and get out of the way. */
function open(key) {
  report.value = key;
  showMealsMenu.value = false;
}
</script>
